/**
 * Mile 12 African Store – Theme JS
 * Handles cart updates, quick add (AJAX + snackbar), mobile menu, and dark mode if enabled.
 */
(function () {
  'use strict';

  // Language switcher in header: toggle dropdown, submit form on option click
  document.addEventListener('click', function (e) {
    var localeBtn = e.target && e.target.closest && e.target.closest('.header-locale-btn');
    var localeOption = e.target && e.target.closest && e.target.closest('.header-locale-option');
    var localeWrap = e.target && e.target.closest && e.target.closest('.header-locale-wrap');
    if (localeOption) {
      var wrap = localeOption.closest('.header-locale-wrap');
      if (wrap) {
        var form = wrap.querySelector('form');
        var input = form && form.querySelector('input[name="language_code"]');
        if (input && localeOption.dataset.locale) {
          input.value = localeOption.dataset.locale;
          form.submit();
        }
      }
      e.preventDefault();
      return;
    }
    if (localeBtn) {
      var wrapper = localeBtn.closest('.header-locale-wrap');
      var list = wrapper && document.getElementById('HeaderLocaleList');
      if (wrapper && list) {
        var isOpen = list.getAttribute('hidden') === null;
        if (isOpen) {
          list.setAttribute('hidden', '');
          wrapper.removeAttribute('data-open');
          localeBtn.setAttribute('aria-expanded', 'false');
        } else {
          list.removeAttribute('hidden');
          wrapper.setAttribute('data-open', 'true');
          localeBtn.setAttribute('aria-expanded', 'true');
        }
      }
      e.preventDefault();
      return;
    }
    if (!localeWrap) {
      document.querySelectorAll('.header-locale-wrap').forEach(function (w) {
        var list = w.querySelector('.header-locale-list');
        if (list) {
          list.setAttribute('hidden', '');
          w.removeAttribute('data-open');
          var btn = w.querySelector('.header-locale-btn');
          if (btn) btn.setAttribute('aria-expanded', 'false');
        }
      });
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      document.querySelectorAll('.header-locale-wrap').forEach(function (w) {
        var list = w.querySelector('.header-locale-list');
        if (list && list.getAttribute('hidden') === null) {
          list.setAttribute('hidden', '');
          w.removeAttribute('data-open');
          var btn = w.querySelector('.header-locale-btn');
          if (btn) btn.setAttribute('aria-expanded', 'false');
        }
      });
    }
  });

  // Mobile menu toggle (delegated so it works even if header loads after script runs)
  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest && e.target.closest('.mobile-menu-btn');
    if (!btn) return;
    var menu = document.querySelector('.header .mobile-menu');
    if (!menu) return;
    var isOpen = menu.style.display === 'block';
    menu.style.display = isOpen ? 'none' : 'block';
    btn.setAttribute('aria-expanded', !isOpen);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var searchOverlay = document.getElementById('SearchOverlay');
    if (searchOverlay && !searchOverlay.hasAttribute('hidden')) {
      searchOverlay.setAttribute('hidden', '');
      var openBtn = document.querySelector('.search-open-btn');
      if (openBtn) openBtn.setAttribute('aria-expanded', 'false');
      openBtn && openBtn.focus();
      return;
    }
    var menu = document.querySelector('.header .mobile-menu');
    var btn = document.querySelector('.header .mobile-menu-btn');
    if (btn && menu && menu.style.display === 'block') {
      menu.style.display = 'none';
      btn.setAttribute('aria-expanded', 'false');
      btn.focus();
    }
  });

  // Search overlay: open/close, predictive suggestions, shopping list mode
  (function () {
    var overlay = document.getElementById('SearchOverlay');
    var input = document.getElementById('SearchOverlayInput');
    var listInput = document.getElementById('SearchOverlayListInput');
    var singleWrap = document.querySelector('[data-search-single-wrap]');
    var listWrap = document.querySelector('[data-search-list-wrap]');
    var listTrigger = document.querySelector('[data-search-list-trigger]');
    var resultsEl = document.querySelector('[data-search-results]');
    var searchRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '';
    var suggestUrlBase = searchRoot + 'search/suggest.json';
    var debounceTimer;
    var strings = (window.theme && window.theme.strings) || {};
    var searchMode = 'list'; // 'single' | 'list' (shopping list is primary/default)

    function setSearchMode(mode) {
      searchMode = mode;
      var singleBtn = overlay && overlay.querySelector('[data-search-mode="single"]');
      var listBtn = overlay && overlay.querySelector('[data-search-mode="list"]');
      if (mode === 'single') {
        if (singleWrap) singleWrap.removeAttribute('hidden');
        if (listWrap) listWrap.setAttribute('hidden', '');
        if (singleBtn) { singleBtn.classList.add('is-active'); singleBtn.setAttribute('aria-pressed', 'true'); singleBtn.setAttribute('aria-selected', 'true'); }
        if (listBtn) { listBtn.classList.remove('is-active'); listBtn.setAttribute('aria-pressed', 'false'); listBtn.setAttribute('aria-selected', 'false'); }
        if (resultsEl) resultsEl.innerHTML = '';
        setTimeout(function () { if (input) input.focus(); }, 50);
      } else {
        if (singleWrap) singleWrap.setAttribute('hidden', '');
        if (listWrap) listWrap.removeAttribute('hidden');
        if (singleBtn) { singleBtn.classList.remove('is-active'); singleBtn.setAttribute('aria-pressed', 'false'); singleBtn.setAttribute('aria-selected', 'false'); }
        if (listBtn) { listBtn.classList.add('is-active'); listBtn.setAttribute('aria-pressed', 'true'); listBtn.setAttribute('aria-selected', 'true'); }
        if (resultsEl) resultsEl.innerHTML = '';
        setTimeout(function () { if (listInput) listInput.focus(); }, 50);
      }
    }

    function openSearch() {
      if (!overlay) return;
      overlay.removeAttribute('hidden');
      var openBtn = document.querySelector('.search-open-btn');
      if (openBtn) openBtn.setAttribute('aria-expanded', 'true');
      if (searchMode === 'list' && listInput) {
        setTimeout(function () { listInput.focus(); }, 50);
      } else if (searchMode === 'single' && input) {
        setTimeout(function () { input.focus(); }, 50);
        if (input.value.trim()) fetchSuggestions(input.value.trim());
      }
    }

    function closeSearch() {
      if (!overlay) return;
      overlay.setAttribute('hidden', '');
      var openBtn = document.querySelector('.search-open-btn');
      if (openBtn) openBtn.setAttribute('aria-expanded', 'false');
      openBtn && openBtn.focus();
    }

    function fetchSuggestionsData(q) {
      if (!q) return Promise.resolve({ products: [], collections: [], pages: [] });
      var params = 'q=' + encodeURIComponent(q) + '&resources[type]=product,collection,page,query&resources[limit]=8&resources[limit_scope]=each&resources[options][unavailable_products]=hide';
      return fetch(suggestUrlBase + '?' + params, { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); });
    }

    function fetchSuggestions(q) {
      if (!resultsEl || !q) return;
      resultsEl.innerHTML = '<div class="search-overlay-loading">' + (strings.search_loading || 'Searching...') + '</div>';
      var params = 'q=' + encodeURIComponent(q) + '&resources[type]=product,collection,page,query&resources[limit]=5&resources[limit_scope]=each&resources[options][unavailable_products]=hide';
      fetch(suggestUrlBase + '?' + params, { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (!resultsEl) return;
          var res = (data && data.resources && data.resources.results) ? data.resources.results : {};
          var products = res.products || [];
          var collections = res.collections || [];
          var pages = res.pages || [];
          var html = '';
          if (products.length) {
            html += '<div class="search-suggestion-group"><div class="search-suggestion-group__title">' + (strings.search_products || 'Products') + '</div>';
            products.slice(0, 5).forEach(function (p) {
              var img = (p.featured_image && p.featured_image.url) ? '<div class="search-suggestion-item__image"><img src="' + p.featured_image.url + '&width=100" alt="' + escapeHtml(p.title || '') + '" width="40" height="40"></div>' : '<div class="search-suggestion-item__image"></div>';
              var price = '';
              if (p.price != null) {
                var num = parseFloat(p.price);
                var cents = (num > 0 && num < 10000 && num !== Math.floor(num)) ? Math.round(num * 100) : Math.round(num);
                price = formatMoney(cents);
              }
              html += '<a href="' + (p.url || '#') + '" class="search-suggestion-item">' + img + '<div class="search-suggestion-item__text"><span class="search-suggestion-item__title">' + escapeHtml(p.title || '') + '</span>' + (price ? '<span class="search-suggestion-item__price">' + price + '</span>' : '') + '</div></a>';
            });
            html += '</div>';
          }
          if (collections.length) {
            html += '<div class="search-suggestion-group"><div class="search-suggestion-group__title">Collections</div>';
            collections.slice(0, 3).forEach(function (c) {
              var img = (c.featured_image && c.featured_image.url) ? '<div class="search-suggestion-item__image"><img src="' + c.featured_image.url + '&width=100" alt="' + escapeHtml(c.title || '') + '" width="40" height="40"></div>' : '<div class="search-suggestion-item__image"></div>';
              html += '<a href="' + (c.url || '#') + '" class="search-suggestion-item">' + img + '<div class="search-suggestion-item__text"><span class="search-suggestion-item__title">' + escapeHtml(c.title || '') + '</span></div></a>';
            });
            html += '</div>';
          }
          if (pages.length) {
            html += '<div class="search-suggestion-group"><div class="search-suggestion-group__title">Pages</div>';
            pages.slice(0, 3).forEach(function (p) {
              html += '<a href="' + (p.url || '#') + '" class="search-suggestion-item"><div class="search-suggestion-item__text"><span class="search-suggestion-item__title">' + escapeHtml(p.title || '') + '</span></div></a>';
            });
            html += '</div>';
          }
          var searchPageUrl = (window.routes && window.routes.search) ? window.routes.search : '/search';
          html += '<a href="' + searchPageUrl + '?q=' + encodeURIComponent(q) + '" class="search-overlay-view-all">' + (strings.search_view_all || 'View all results') + '</a>';
          if (!products.length && !collections.length && !pages.length) {
            html = '<div class="search-overlay-empty">' + (strings.search_no_results || 'No results') + '</div>';
          }
          resultsEl.innerHTML = html;
        })
        .catch(function () {
          if (resultsEl) resultsEl.innerHTML = '<div class="search-overlay-empty">' + (strings.search_no_results || 'No results') + '</div>';
        });
    }

    function levenshtein(a, b) {
      if (!a.length) return b.length;
      if (!b.length) return a.length;
      var matrix = [];
      for (var i = 0; i <= b.length; i++) matrix[i] = [i];
      for (var j = 0; j <= a.length; j++) matrix[0][j] = j;
      for (var i = 1; i <= b.length; i++) {
        for (var j = 1; j <= a.length; j++) {
          if (b.charAt(i - 1) === a.charAt(j - 1)) matrix[i][j] = matrix[i - 1][j - 1];
          else matrix[i][j] = Math.min(matrix[i - 1][j - 1] + 1, matrix[i][j - 1] + 1, matrix[i - 1][j] + 1);
        }
      }
      return matrix[b.length][a.length];
    }
    function fuzzyScore(query, text) {
      if (!query || !text) return 0;
      var q = (query + '').toLowerCase().trim().replace(/\s+/g, ' ');
      var t = (text + '').toLowerCase().trim().replace(/\s+/g, ' ');
      if (q === t) return 1;
      if (t.indexOf(q) >= 0) return 0.95;
      if (q.indexOf(t) >= 0) return 0.85;
      var qWords = q.split(/\s+/).filter(Boolean);
      var tWords = t.split(/\s+/).filter(Boolean);
      var wordMatches = 0;
      for (var i = 0; i < qWords.length; i++) {
        for (var j = 0; j < tWords.length; j++) {
          if (tWords[j].indexOf(qWords[i]) >= 0 || qWords[i].indexOf(tWords[j]) >= 0) { wordMatches++; break; }
        }
      }
      var wordScore = qWords.length ? wordMatches / qWords.length : 0;
      var maxLen = Math.max(q.length, t.length, 1);
      var levDist = levenshtein(q, t);
      var levScore = 1 - (levDist / maxLen);
      return Math.max(wordScore * 0.9, levScore * 0.9, 0);
    }
    function buildListRowHtml(label, data) {
      var res = (data && data.resources && data.resources.results) ? data.resources.results : {};
      var products = res.products || [];
      products = products.slice().sort(function (a, b) {
        var scoreA = fuzzyScore(label, (a && a.title) || '');
        var scoreB = fuzzyScore(label, (b && b.title) || '');
        return scoreB - scoreA;
      });
      if (products.length === 0) {
        return '<div class="search-list-row search-list-row--empty"><div class="search-list-row__title">' + escapeHtml(label) + '</div><div class="search-list-row__strip">' + (strings.search_no_results_short || 'No results') + '</div></div>';
      }
      var stripHtml = products.map(function (p) {
        var img = (p.featured_image && p.featured_image.url) ? '<div class="search-list-row__item-img"><img src="' + p.featured_image.url + '&width=200" alt="' + escapeHtml(p.title || '') + '" width="200" height="200" loading="lazy"></div>' : '<div class="search-list-row__item-img"></div>';
        var price = '';
        if (p.price != null) {
          var num = parseFloat(p.price);
          var cents = (num > 0 && num < 10000 && num !== Math.floor(num)) ? Math.round(num * 100) : Math.round(num);
          price = '<div class="search-list-row__item-price">' + formatMoney(cents) + '</div>';
        }
        return '<div class="search-list-row__item"><a href="' + (p.url || '#') + '">' + img + '<div class="search-list-row__item-title">' + escapeHtml(p.title || '') + '</div>' + price + '</a></div>';
      }).join('');
      return '<div class="search-list-row"><div class="search-list-row__title">' + escapeHtml(label) + '</div><div class="search-list-row__strip">' + stripHtml + '</div></div>';
    }

    function runListSearch() {
      if (!listInput) return;
      var text = (listInput.value || '').trim();
      if (!text) {
        if (resultsEl) resultsEl.innerHTML = '<div class="search-overlay-empty">Enter at least one item (one per line), then click Search list.</div>';
        return;
      }
      var lines = text.split(/\n/).map(function (s) { return s.trim(); }).filter(Boolean);
      if (lines.length === 0) {
        if (resultsEl) resultsEl.innerHTML = '<div class="search-overlay-empty">Enter at least one item (one per line), then click Search list.</div>';
        return;
      }
      var listPageUrl = (overlay && overlay.getAttribute('data-shopping-list-url')) || ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '') + 'search?view=shopping-list';
      if (listPageUrl) {
        try { sessionStorage.setItem('shoppingListSearch', JSON.stringify(lines)); } catch (e) {}
        closeSearch();
        window.location.href = listPageUrl;
        return;
      }
      if (!resultsEl) return;
      resultsEl.innerHTML = lines.map(function (label) {
        return '<div class="search-list-row search-list-row--loading"><div class="search-list-row__title">' + escapeHtml(label) + '</div><div class="search-list-row__strip">' + (strings.search_loading || 'Searching...') + '</div></div>';
      }).join('');

      var rowEls = resultsEl.querySelectorAll('.search-list-row');
      Promise.all(lines.map(function (q) { return fetchSuggestionsData(q); })).then(function (results) {
        if (!resultsEl) return;
        results.forEach(function (data, i) {
          if (rowEls[i]) rowEls[i].outerHTML = buildListRowHtml(lines[i], data);
        });
      }).catch(function () {
        if (resultsEl) resultsEl.innerHTML = '<div class="search-overlay-empty">Something went wrong. Try again.</div>';
      });
    }

    function escapeHtml(s) {
      var div = document.createElement('div');
      div.textContent = s;
      return div.innerHTML;
    }

    document.addEventListener('click', function (e) {
      if (e.target && e.target.closest && e.target.closest('.search-open-btn')) {
        e.preventDefault();
        openSearch();
        return;
      }
      if (e.target && e.target.closest && (e.target.closest('[data-search-close]') || e.target.closest('.search-overlay-backdrop'))) {
        closeSearch();
      }
    });

    if (input && resultsEl) {
      input.addEventListener('input', function () {
        if (searchMode !== 'single') return;
        var q = (input.value || '').trim();
        clearTimeout(debounceTimer);
        if (!q) {
          resultsEl.innerHTML = '';
          return;
        }
        debounceTimer = setTimeout(function () { fetchSuggestions(q); }, 250);
      });
      input.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') {
          closeSearch();
          e.preventDefault();
        }
      });
    }

    if (listTrigger) listTrigger.addEventListener('click', runListSearch);
    if (overlay) {
      overlay.querySelectorAll('[data-search-mode]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var mode = btn.getAttribute('data-search-mode');
          if (mode) setSearchMode(mode);
        });
      });
      overlay.addEventListener('click', function (e) {
        if (e.target.classList && e.target.classList.contains('search-suggestion-item') || (e.target.closest && e.target.closest('.search-suggestion-item')) || (e.target.classList && e.target.classList.contains('search-overlay-view-all'))) {
          closeSearch();
        }
        if (e.target.closest && e.target.closest('.search-list-row__item a')) closeSearch();
      });
    }
  })();

  // Format cents as money using theme.moneyFormat (e.g. "{{amount}}" or "${{amount}}")
  function formatMoney(cents) {
    var format = (window.theme && window.theme.moneyFormat) || '{{amount}}';
    var amount = (cents / 100).toFixed(2);
    var amountNoDecimals = String(Math.round(cents / 100));
    return format
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, amount.replace('.', ','))
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, amountNoDecimals)
      .replace(/\{\{\s*amount\s*\}\}/g, amount);
  }

  function formatItemCount(count) {
    var strings = window.theme && window.theme.strings;
    if (count === 1) return (strings && strings.item_count_one) || '1 item';
    var tpl = (strings && strings.item_count_other) || '{{ count }} items';
    return tpl.replace(/\{\{\s*count\s*\}\}/g, String(count)).replace('[count]', String(count));
  }

  var FLOATING_WIDGET_MESSAGE_SELECTORS = [
    '#shopify-chat',
    '#dummy-chat-button-iframe',
    'iframe#ShopifyChat',
    'inbox-online-store-chat'
  ];

  var FLOATING_WIDGET_REWARDS_SELECTORS = [
    'shopify-rewards',
    '#shopify-rewards',
    '#smile-ui-lite-launcher-frame-container',
    '#joy-reward-launcher',
    '.rivo-rewards-button'
  ];

  function isMobileCartBarViewport() {
    return window.matchMedia('(max-width: 1023px)').matches;
  }

  function syncCartStickyBarHeight() {
    var bar = document.querySelector('.cart-sticky-bar.is-visible:not([hidden])');
    var cartPageBar = document.querySelector('.cart-page-sticky-checkout');
    var height = 0;
    if (document.body.classList.contains('has-cart-sticky-bar') && bar && isMobileCartBarViewport()) {
      height = Math.ceil(bar.getBoundingClientRect().height);
    } else if (document.body.classList.contains('has-cart-page-sticky-checkout') && cartPageBar && isMobileCartBarViewport()) {
      height = Math.ceil(cartPageBar.getBoundingClientRect().height);
    }
    document.documentElement.style.setProperty('--cart-sticky-bar-height', height ? height + 'px' : '0px');
    document.documentElement.style.setProperty('--cart-page-sticky-height', height ? height + 'px' : '0px');
    return height;
  }

  function clearFloatingWidgetOffset(el) {
    if (el.getAttribute('data-theme-cart-bar-offset') === 'true') {
      el.style.removeProperty('bottom');
      el.removeAttribute('data-theme-cart-bar-offset');
    }
  }

  function repositionFloatingWidgets() {
    var cartBarHeight = syncCartStickyBarHeight();
    var isMobile = isMobileCartBarViewport();
    var safeExtra = 8;
    var hasBottomBar = document.body.classList.contains('has-cart-sticky-bar') ||
      document.body.classList.contains('has-cart-page-sticky-checkout');

    FLOATING_WIDGET_MESSAGE_SELECTORS.forEach(function (selector) {
      document.querySelectorAll(selector).forEach(function (el) {
        if (el.closest('.cart-sticky-bar') || el.closest('.product-sticky-bar') || el.closest('.cart-page-sticky-checkout')) return;
        if (!isMobile || !cartBarHeight || !hasBottomBar) {
          clearFloatingWidgetOffset(el);
          return;
        }
        el.style.setProperty('bottom', (cartBarHeight + safeExtra) + 'px', 'important');
        el.setAttribute('data-theme-cart-bar-offset', 'true');
      });
    });

    FLOATING_WIDGET_REWARDS_SELECTORS.forEach(function (selector) {
      document.querySelectorAll(selector).forEach(function (el) {
        if (el.closest('.cart-sticky-bar') || el.closest('.product-sticky-bar') || el.closest('.cart-page-sticky-checkout')) return;
        if (!isMobile || !cartBarHeight || !hasBottomBar) {
          clearFloatingWidgetOffset(el);
          return;
        }
        el.style.setProperty('bottom', (cartBarHeight + 76) + 'px', 'important');
        el.setAttribute('data-theme-cart-bar-offset', 'true');
      });
    });
  }

  var floatingWidgetObserverTimer;
  function scheduleFloatingWidgetReposition() {
    clearTimeout(floatingWidgetObserverTimer);
    floatingWidgetObserverTimer = setTimeout(repositionFloatingWidgets, 100);
  }

  function initFloatingWidgetOffset() {
    repositionFloatingWidgets();
    window.addEventListener('resize', scheduleFloatingWidgetReposition);
    if (typeof MutationObserver !== 'undefined') {
      var observer = new MutationObserver(scheduleFloatingWidgetReposition);
      observer.observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFloatingWidgetOffset);
  } else {
    initFloatingWidgetOffset();
  }

  function updateCartStickyBar(cart) {
    var bar = document.querySelector('[data-cart-sticky-bar]');
    if (!bar) return;
    var count = cart && cart.item_count != null ? cart.item_count : 0;
    var countEl = bar.querySelector('[data-cart-sticky-count]');
    var subtotalEl = bar.querySelector('[data-cart-sticky-subtotal]');
    if (count > 0) {
      bar.removeAttribute('hidden');
      bar.setAttribute('aria-hidden', 'false');
      bar.classList.add('is-visible');
      document.body.classList.add('has-cart-sticky-bar');
      if (countEl) countEl.textContent = formatItemCount(count);
      if (subtotalEl && cart.total_price != null) subtotalEl.textContent = formatMoney(cart.total_price);
    } else {
      bar.setAttribute('hidden', '');
      bar.setAttribute('aria-hidden', 'true');
      bar.classList.remove('is-visible');
      document.body.classList.remove('has-cart-sticky-bar');
    }
    scheduleFloatingWidgetReposition();
  }

  function freeShippingMessage(totalCents, thresholdCents, compact) {
    var strings = (window.theme && window.theme.strings) || {};
    if (totalCents >= thresholdCents) {
      return strings.free_shipping_unlocked || "You've unlocked free shipping!";
    }
    var remaining = thresholdCents - totalCents;
    if (remaining < 0) remaining = 0;
    var amount = formatMoney(remaining);
    var tpl = compact ? strings.free_shipping_away_compact : strings.free_shipping_away;
    return (tpl || '{{ amount }} away from free shipping')
      .replace(/\{\{\s*amount\s*\}\}/g, amount)
      .replace('[amount]', amount);
  }

  function updateFreeShippingProgress(cart) {
    var threshold = (window.theme && window.theme.freeShippingThresholdCents) || 0;
    if (!threshold || !cart) return;
    var total = cart.total_price || 0;
    var pct = Math.min(100, Math.round((total * 100) / threshold));
    document.querySelectorAll('[data-free-shipping-progress]').forEach(function (el) {
      var compact = el.classList.contains('free-shipping-progress--compact');
      var msgEl = el.querySelector('[data-free-shipping-message]');
      var fillEl = el.querySelector('[data-free-shipping-fill]');
      if (msgEl) msgEl.textContent = freeShippingMessage(total, threshold, compact);
      if (fillEl) fillEl.style.width = pct + '%';
    });
    scheduleFloatingWidgetReposition();
  }

  function updateCartPageFromCart(cart) {
    if (!cart || !document.querySelector('.cart-page')) return;

    var subtotalEl = document.querySelector('[data-cart-subtotal]');
    if (subtotalEl && cart.total_price != null) {
      var label = subtotalEl.getAttribute('data-label') || 'Subtotal';
      subtotalEl.textContent = label + ': ' + formatMoney(cart.total_price);
    }

    var stickySubtotalEl = document.querySelector('[data-cart-page-sticky-subtotal]');
    if (stickySubtotalEl && cart.total_price != null) {
      stickySubtotalEl.textContent = formatMoney(cart.total_price);
    }
    scheduleFloatingWidgetReposition();

    if (cart.item_count === 0) {
      window.location.reload();
      return;
    }

    var itemsByKey = {};
    (cart.items || []).forEach(function (item) {
      itemsByKey[item.key] = item;
    });

    document.querySelectorAll('.cart-line-item[data-line-key]').forEach(function (row) {
      var key = row.getAttribute('data-line-key');
      var item = itemsByKey[key];
      if (!item) {
        row.remove();
        return;
      }
      var input = row.querySelector('[data-quantity-input]');
      var display = row.querySelector('[data-quantity-display]');
      if (input) input.value = String(item.quantity);
      if (display) display.textContent = String(item.quantity);
      var linePriceEl = row.querySelector('[data-line-price]');
      if (linePriceEl) linePriceEl.textContent = formatMoney(item.final_line_price || item.line_price);
      row.setAttribute('data-unit-price-cents', String(item.final_price));
      if (item.line != null) row.setAttribute('data-line', String(item.line));
    });

    // Refresh 1-based line indexes after removals
    document.querySelectorAll('.cart-line-item[data-line-key]').forEach(function (row, index) {
      row.setAttribute('data-line', String(index + 1));
    });
  }

  var cartChangeTimers = {};

  function changeCartLine(lineKey, quantity, onDone, lineNumber) {
    if ((!lineKey && !lineNumber) || !window.routes || !window.routes.cartChangeJson) {
      if (onDone) onDone(null);
      return;
    }
    var payload = { quantity: quantity };
    if (lineNumber) {
      payload.line = lineNumber;
    } else {
      payload.id = lineKey;
    }
    fetch(window.routes.cartChangeJson, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(payload),
      credentials: 'same-origin'
    })
      .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); })
      .then(function (res) {
        if (res.ok && res.data) {
          updateCartUI(res.data);
          updateCartPageFromCart(res.data);
          if (onDone) onDone(res.data);
        } else {
          fetchCartAndUpdate(function (cart) {
            updateCartPageFromCart(cart);
            if (onDone) onDone(cart);
          });
          var errMsg = (res.data && res.data.description) ? res.data.description : 'Could not update cart';
          showSnackbar(errMsg, 4000);
        }
      })
      .catch(function () {
        fetchCartAndUpdate(function (cart) {
          updateCartPageFromCart(cart);
          if (onDone) onDone(cart);
        });
        showSnackbar('Could not update cart', 4000);
      });
  }

  function scheduleCartLineChange(lineKey, quantity, lineNumber) {
    var timerKey = lineKey || ('line-' + lineNumber);
    clearTimeout(cartChangeTimers[timerKey]);
    cartChangeTimers[timerKey] = setTimeout(function () {
      changeCartLine(lineKey, quantity, null, lineNumber);
    }, 400);
  }

  function updateCartUI(cart) {
    if (!cart) return;
    window.theme.cartCount = cart.item_count;
    var badge = document.querySelector('.cart-count');
    if (badge && cart.item_count !== undefined) badge.textContent = cart.item_count;
    updateCartStickyBar(cart);
    updateFreeShippingProgress(cart);
  }

  function fetchCartAndUpdate(onDone) {
    if (!window.routes || !window.routes.cartJson) {
      if (onDone) onDone();
      return;
    }
    fetch(window.routes.cartJson)
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        updateCartUI(cart);
        if (onDone) onDone(cart);
      })
      .catch(function () {
        if (onDone) onDone();
      });
  }

  // Snackbar: show message, auto-hide after delay
  function showSnackbar(messageHtml, duration) {
    duration = duration || 4000;
    var el = document.getElementById('snackbar');
    if (!el) return;
    el.innerHTML = messageHtml;
    el.removeAttribute('hidden');
    el.classList.add('is-visible');
    clearTimeout(el._snackbarTimer);
    el._snackbarTimer = setTimeout(function () {
      el.classList.remove('is-visible');
      el.setAttribute('hidden', '');
    }, duration);
  }

  // Add variant to cart via AJAX (shared for form submit and variant click)
  function quickAddToCart(variantId, quantity, onDone, opts) {
    quantity = quantity || 1;
    opts = opts || {};
    if (!variantId || !window.routes || !window.routes.cartAddJson) return false;
    var cartUrl = window.routes.cart || '/cart';
    var checkoutUrl = (window.routes && window.routes.checkout) || '/checkout';
    var addedText = (window.theme && window.theme.strings && window.theme.strings.added_to_cart) || 'Added to cart';
    var viewCartText = (window.theme && window.theme.strings && window.theme.strings.view_cart) || 'View cart';
    var checkoutText = (window.theme && window.theme.strings && window.theme.strings.checkout) || 'Checkout';
    fetch(window.routes.cartAddJson, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: quantity }] }),
      credentials: 'same-origin'
    })
      .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); })
      .then(function (res) {
        if (res.ok && res.data) {
          fetchCartAndUpdate();
          var links = '<a href="' + cartUrl + '">' + viewCartText + '</a> · <a href="' + checkoutUrl + '">' + checkoutText + '</a>';
          showSnackbar(addedText + ' ' + links, 5000);
        } else {
          var errMsg = (res.data && res.data.description) ? res.data.description : 'Could not add to cart';
          showSnackbar(errMsg, 5000);
        }
        if (onDone) onDone();
      })
      .catch(function () {
        showSnackbar('Could not add to cart', 4000);
        if (onDone) onDone();
      });
    return true;
  }

  function handleQuickAddForm(form) {
    if (!form) return false;
    var hasVariants = form.getAttribute('data-has-variants') === 'true';
    var picker = form.querySelector('[data-product-card-variants]');
    var addBtn = form.querySelector('[data-product-card-add-btn]');
    if (hasVariants && picker && addBtn && picker.hasAttribute('hidden')) {
      picker.removeAttribute('hidden');
      addBtn.setAttribute('hidden', '');
      return true;
    }
    var idInput = form.querySelector('input[name="id"]');
    var qtyInput = form.querySelector('input[name="quantity"]');
    var variantId = idInput ? parseInt(idInput.value, 10) : NaN;
    var quantity = parseInt((qtyInput && qtyInput.value) || '1', 10) || 1;
    if (!variantId || !quickAddToCart(variantId, quantity)) {
      showSnackbar('Could not add to cart', 4000);
    }
    return true;
  }

  // Product page form – AJAX add with checkout link in snackbar
  document.addEventListener('submit', function (e) {
    var productForm = e.target && e.target.closest && e.target.closest('#product-form');
    if (productForm) {
      e.preventDefault();
      var idInput = productForm.querySelector('input[name="id"]');
      var qtyInput = productForm.querySelector('input[name="quantity"]');
      var addBtn = productForm.querySelector('[data-product-add-btn]');
      if (addBtn && addBtn.disabled) return;
      if (!idInput || !window.routes || !window.routes.cartAddJson) {
        showSnackbar('Could not add to cart', 4000);
        return;
      }
      var variantId = parseInt(idInput.value, 10);
      var quantity = parseInt((qtyInput && qtyInput.value) || '1', 10);
      if (!quickAddToCart(variantId, quantity, null, { showCheckout: true })) {
        showSnackbar('Could not add to cart', 4000);
      }
      return;
    }

    var form = e.target && e.target.closest && e.target.closest('.quick-add-form');
    if (!form) return;
    e.preventDefault();
    handleQuickAddForm(form);
  });

  // Product card variant selection: click adds to cart immediately, brief visual cue, then revert to Add to cart button
  var REVERT_VARIANT_UI_MS = 1200;
  document.addEventListener('click', function (e) {
    var variantBtn = e.target && e.target.closest && e.target.closest('.product-card-variant-btn');
    if (variantBtn && !variantBtn.disabled) {
      var form = variantBtn.closest('.quick-add-form');
      if (!form) return;
      var variantId = parseInt(variantBtn.getAttribute('data-variant-id'), 10);
      var idInput = form.querySelector('[data-variant-id-input]');
      var picker = form.querySelector('[data-product-card-variants]');
      var addBtn = form.querySelector('[data-product-card-add-btn]');
      if (idInput) idInput.value = variantId;
      variantBtn.classList.add('is-selected');
      var siblings = variantBtn.parentElement && variantBtn.parentElement.querySelectorAll('.product-card-variant-btn');
      if (siblings) siblings.forEach(function (b) { if (b !== variantBtn) b.classList.remove('is-selected'); });
      quickAddToCart(variantId, 1);
      setTimeout(function () {
        if (siblings) siblings.forEach(function (b) { b.classList.remove('is-selected'); });
        if (picker) picker.setAttribute('hidden', '');
        if (addBtn) addBtn.removeAttribute('hidden');
      }, REVERT_VARIANT_UI_MS);
      return;
    }
  });

  function applyQuantityChange(group, qty) {
    var input = group.querySelector('[data-quantity-input]');
    var display = group.querySelector('[data-quantity-display]');
    if (!input) return;
    input.value = String(qty);
    if (display) display.textContent = String(qty);

    var row = group.closest('.cart-line-item');
    if (!row) return;

    var unitCents = parseInt(row.getAttribute('data-unit-price-cents'), 10) || 0;
    var linePriceEl = row.querySelector('[data-line-price]');
    if (linePriceEl && unitCents) {
      linePriceEl.textContent = formatMoney(unitCents * qty);
    }
    var originalCents = row.getAttribute('data-original-unit-price-cents');
    if (originalCents) {
      var originalPriceEl = row.querySelector('[data-line-original-price]');
      if (originalPriceEl) {
        originalPriceEl.textContent = formatMoney(parseInt(originalCents, 10) * qty);
      }
    }

    var lineKey = row.getAttribute('data-line-key');
    var lineNumber = parseInt(row.getAttribute('data-line'), 10);
    if (lineKey || lineNumber) {
      scheduleCartLineChange(lineKey, qty, lineNumber || null);
    }
  }

  // Cart / product quantity +/- buttons: optimistic UI + debounced cart/change.js sync
  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest && e.target.closest('.cart-qty-btn');
    if (!btn || btn.disabled) return;
    var group = btn.closest('.cart-quantity-selector');
    if (!group) return;
    e.preventDefault();
    e.stopPropagation();
    var input = group.querySelector('[data-quantity-input]');
    if (!input) return;
    var action = btn.getAttribute('data-action');
    var minQty = parseInt(group.getAttribute('data-min-quantity'), 10);
    if (isNaN(minQty)) minQty = 0;
    var qty = parseInt(input.value, 10);
    if (isNaN(qty)) qty = minQty;
    if (action === 'plus') {
      qty += 1;
    } else if (action === 'minus' && qty > minQty) {
      qty -= 1;
    } else {
      return;
    }
    applyQuantityChange(group, qty);
  });

  // Cart quantity direct input changes
  document.addEventListener('change', function (e) {
    var input = e.target && e.target.closest && e.target.closest('.cart-line-item [data-quantity-input]');
    if (!input) return;
    var group = input.closest('.cart-quantity-selector');
    if (!group) return;
    var minQty = parseInt(group.getAttribute('data-min-quantity'), 10);
    if (isNaN(minQty)) minQty = 0;
    var qty = parseInt(input.value, 10);
    if (isNaN(qty) || qty < minQty) qty = minQty;
    applyQuantityChange(group, qty);
  });
  // Hero slider: multiple slides with arrows, dots, autoplay
  (function () {
    var sliders = document.querySelectorAll('.hero-slider');
    sliders.forEach(function (section) {
      var slides = section.querySelectorAll('.hero-slide');
      var count = slides.length;
      if (count <= 1) return;

      var dots = section.querySelectorAll('[data-hero-dot]');
      var prevBtn = section.querySelector('[data-hero-prev]');
      var nextBtn = section.querySelector('[data-hero-next]');
      var autoplay = section.getAttribute('data-hero-autoplay') === 'true';
      var intervalSec = parseInt(section.getAttribute('data-hero-interval'), 10) || 5;
      var current = 0;
      var timer = null;

      function goTo(index) {
        current = (index + count) % count;
        slides.forEach(function (s, i) {
          s.classList.toggle('is-active', i === current);
        });
        dots.forEach(function (d, i) {
          d.setAttribute('aria-selected', i === current ? 'true' : 'false');
        });
      }

      function next() {
        goTo(current + 1);
        resetAutoplay();
      }

      function prev() {
        goTo(current - 1);
        resetAutoplay();
      }

      function resetAutoplay() {
        if (!autoplay) return;
        clearInterval(timer);
        timer = setInterval(next, intervalSec * 1000);
      }

      if (prevBtn) prevBtn.addEventListener('click', prev);
      if (nextBtn) nextBtn.addEventListener('click', next);
      dots.forEach(function (dot, i) {
        dot.addEventListener('click', function () {
          goTo(i);
          resetAutoplay();
        });
      });

      if (autoplay) {
        timer = setInterval(next, intervalSec * 1000);
      }
    });
  })();

  if (typeof window !== 'undefined') {
    window.theme = window.theme || {};
    window.theme.quickAddToCart = quickAddToCart;
    window.theme.showSnackbar = showSnackbar;
    window.theme.updateCartUI = updateCartUI;
    window.theme.fetchCartAndUpdate = fetchCartAndUpdate;
  }
})();
